import { render, staticRenderFns } from "./ReportCheckListLegend.vue?vue&type=template&id=590d8ce7&scoped=true&"
import script from "./ReportCheckListLegend.vue?vue&type=script&lang=js&"
export * from "./ReportCheckListLegend.vue?vue&type=script&lang=js&"
import style0 from "./ReportCheckListLegend.vue?vue&type=style&index=0&id=590d8ce7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590d8ce7",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItemLabel,QList,QItem,QItemSection,QIcon} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItemLabel,QList,QItem,QItemSection,QIcon}, component.options.components || {})
